import Swal from 'sweetalert2'
import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class ProjectService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.GET_BY_ID = '/{id}';
        this.PROJECT = '/api/project';
        this.GET_BY_ID_LIST = '/list';
        this.GET_PROJECT_LIST_BY_USER = '/list/project/user/{userId}';
        this.GET_SIMPLE_USER_LIST_BY_PROJECT = '/simple/list/user/project/{projectId}';
        this.GET_SIMPLE_ASSIGNEE_USER_LIST_BY_PROJECT = "/simple/list/assignee/user/project/{projectId}";
    }

    async getProject(id) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_BY_ID;
            url = url
                .replace('{id}', id)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getProjectListByUserId(id) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_PROJECT_LIST_BY_USER;
            url = url
                .replace('{userId}', id)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getProjectListByIdList(projectIdList) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.PROJECT + this.GET_BY_ID_LIST;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(projectIdList)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async getSimpleUserListForProject(projectId) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_SIMPLE_USER_LIST_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId);
            const projects = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projects;
        } catch (err) {
            console.log(err);
        }
    }

    async getSimpleAssigneeUserListForProject(projectId) {
        try {
            let url = window.location.origin + this.PROJECT + this.GET_SIMPLE_ASSIGNEE_USER_LIST_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId);
            const projects = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projects;
        } catch (err) {
            console.log(err);
        }
    }

}

export default ProjectService;
